import React, { type FunctionComponent } from 'react'
import styled from '@emotion/styled'
import { colors } from '@retailer-platform/shared-components'

interface Props {
  imageUrl: string
  width: string
  height: string
}

const PlaceholderImage = styled.div<{ width: string; height: string }>(
  {
    border: `1px dashed ${colors.GRAYSCALE.X30}`,
  },
  props => ({ width: props.width, height: props.height })
)

export const CollectionsViewImage: FunctionComponent<Props> = ({ imageUrl, width, height }) => {
  if (!imageUrl || imageUrl === '') {
    return <PlaceholderImage width={width} height={height} />
  }

  return <img src={imageUrl} css={{ width }} />
}
